import { fetchCentreStatistics } from '@/services/statistics'
import { IS_LOADING_STATISTICS, SET_STATISTICS } from '@/store/statistics'

const getAllStatistics = (fetchAllStatistics) => async (dispatch) => {
  dispatch(SET_STATISTICS(fetchAllStatistics))
}

const getCentreStatistics = (params) => async (dispatch) => {
  try {
    const fetchAllStatistics = await fetchCentreStatistics(params)
    dispatch(IS_LOADING_STATISTICS(true))
    await dispatch(SET_STATISTICS(fetchAllStatistics))
    dispatch(IS_LOADING_STATISTICS(false))
  } catch (error) {
    console.error('Error fetching centre statistics:', error)
    dispatch(IS_LOADING_STATISTICS(false))
  }
}

export { getAllStatistics, getCentreStatistics }
